import { get } from 'lodash'

export default function(fields = {}) {
  let assessorDetail = {}

  let assessorWWC = {}

  let note = get(fields, 'note')

  if (get(fields, 'detail.assessorDetail')) {
    assessorDetail = { ...fields.detail.assessorDetail }
    note = get(fields, 'detail.assessorDetail.note')
  } else {
    if (get(fields, 'assessors.detail.person.assessorDetail')) {
      assessorDetail = { ...fields.assessors.detail.person.assessorDetail }
      note = get(fields, 'assessors.detail.person.assessorDetail.note')
    }
  }

  if (get(fields, 'assessor.assessorWWC')) {
    assessorWWC = { ...fields.assessor.assessorWWC }
  }

  return {
    id: get(fields, 'assessors.detail.person.id'),
    phone: get(fields, 'assessors.detail.person.phone'),
    secondaryPhone: get(fields, 'assessors.detail.person.secondaryPhone'),
    title: get(fields, 'assessors.detail.person.title'),
    firstName: get(fields, 'assessors.detail.person.firstName'),
    lastName: get(fields, 'assessors.detail.person.lastName'),
    email: get(fields, 'assessors.detail.person.email'),
    secondaryEmail: get(fields, 'assessors.detail.person.secondaryEmail'),
    tertiaryEmail: get(fields, 'assessors.detail.person.tertiaryEmail'),
    address: {
      line1: get(fields, 'assessors.detail.person.address.line1'),
      line2: get(fields, 'assessors.detail.person.address.line2'),
      city: get(fields, 'assessors.detail.person.address.city'),
      zipCode: get(fields, 'assessors.detail.person.address.zipCode'),
      stateOrProvinceOrRegion: get(fields, 'assessors.detail.person.address.stateOrProvinceOrRegion'),
      country: { id: get(fields, 'assessors.detail.person.address.country.id') }
    },
    phoneType: {
      value: get(fields, 'assessors.detail.person.phoneType.value')
    },
    secondaryPhoneType: {
      value: get(fields, 'assessors.detail.person.secondaryPhoneType.value')
    },
    birthDate: get(fields, 'assessors.detail.person.birthDate'),
    photoUrl: get(fields, 'assessors.detail.person.photoUrl'),
    isTestUser: get(fields, 'assessors.detail.person.isTestUser'),
    note,
    assessorDetail,
    assessorWWC
  }
}
